import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'

const AdminEditGroup = ({ show, onClose, groupId, onGroupUpdated }) => {
  const [groupName, setGroupName] = useState('')
  const [status, setStatus] = useState('active')

  useEffect(() => {
    if (groupId) {
      const fetchGroup = async () => {
        try {
          const response = await fetch(`/api/v1/admin/group/${groupId}`)
          if (response.ok) {
            const data = await response.json()
            setGroupName(data.groupName)
            setStatus(data.status === 1 ? 'active' : 'inactive')
          } else {
            toast.error('Failed to fetch group details')
          }
        } catch (error) {
          toast.error('An unexpected error occurred')
        }
      }
      fetchGroup()
    }
  }, [groupId])

  const handleSubmit = async (e) => {
    e.preventDefault()

    try {
      const response = await fetch(`/api/v1/admin/group/update/${groupId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          groupName,
          status: status === 'active' ? 1 : 0,
        }),
      })

      if (response.ok) {
        const updatedGroup = await response.json()
        onGroupUpdated(updatedGroup)
        onClose()
      } else {
        toast.error('Failed to update group')
      }
    } catch (error) {
      toast.error('An unexpected error occurred')
    }
  }

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Group</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <div className='mb-3'>
            <label htmlFor='groupName' className='form-label'>
              Group Name
            </label>
            <input
              type='text'
              className='form-control'
              id='groupName'
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
              required
            />
          </div>
          <div className='mb-3'>
            <label className='form-label'>Status</label>
            <div className='d-flex align-items-center'>
              <div className='form-check me-3'>
                <input
                  className='form-check-input'
                  type='radio'
                  id='activeStatus'
                  name='status'
                  value='active'
                  checked={status === 'active'}
                  onChange={(e) => setStatus(e.target.value)}
                />
                <label className='form-check-label' htmlFor='activeStatus'>
                  Active
                </label>
              </div>
              <div className='form-check'>
                <input
                  className='form-check-input'
                  type='radio'
                  id='inactiveStatus'
                  name='status'
                  value='inactive'
                  checked={status === 'inactive'}
                  onChange={(e) => setStatus(e.target.value)}
                />
                <label className='form-check-label' htmlFor='inactiveStatus'>
                  Inactive
                </label>
              </div>
            </div>
          </div>
          <div className='text-end'>
            <button type='submit' className='btn btn-primary me-3'>
              Save
            </button>
            <button
              type='button'
              className='btn btn-secondary'
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  )
}

export default AdminEditGroup
